export enum ReloadEpisode {
    reloadAll = 'reloadAll',
    reloadSelf = 'reloadSelf',
}
